import cleveland from 'images/cleveland-sq.jpg';
import cotswold from 'images/cotswold-sq.jpg';
import glyndwr from 'images/glyndwr-sq.jpg';
import hadrian from 'images/hadrian-sq.jpg';
import northdowns from 'images/northdowns-sq.jpg';
import offas from 'images/offas-sq.jpg';
import peddars from 'images/peddars-sq.jpg';
import pembrokeshire from 'images/pembrokeshire-sq.jpg';
import pennineway from 'images/pennineway-sq.jpg';
import ridgeway from 'images/ridgeway-sq.jpg';
import southdowns from 'images/southdowns-sq.jpg';
import southwest from 'images/southwest-sq.jpg';
import thames from 'images/thames-sq.jpg';
import wolds from 'images/wolds-sq.jpg';
import map from 'images/map-sq.jpg';

export default {
  cleveland,
  cotswold,
  glyndwr,
  hadrian,
  northdowns,
  offas,
  peddars,
  pembrokeshire,
  pennineway,
  ridgeway,
  southdowns,
  southwest,
  thames,
  wolds,
  map,
};
